package fyi.moko.hotpl.data.repository

import fyi.moko.hotpl.domain.model.YellowPageEntry
import fyi.moko.hotpl.domain.repository.YellowPageRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf

/**
 * In-memory stub implementation of [YellowPageRepository] for the JS/web target.
 * The JS target does not descend from `nativeAndAndroidMain`, so it cannot use Room.
 * This stub keeps the Koin graph consistent and lets the web UI compile; it returns
 * empty results until a web-specific directory cache (e.g. localStorage-backed) is built.
 */
class JsYellowPageRepository : YellowPageRepository {
    override suspend fun syncRegion(regionKey: String): Result<Unit> =
        Result.success(Unit)

    override fun observeCachedEntries(regionKey: String): Flow<List<YellowPageEntry>> =
        flowOf(emptyList())

    override suspend fun searchLocal(prefix: String, limit: Int): List<YellowPageEntry> =
        emptyList()

    override suspend fun submitPendingEntry(entry: YellowPageEntry): Result<Unit> =
        Result.success(Unit)

    override suspend fun seedLocalEntries(entries: List<YellowPageEntry>) {
        // No local cache on the web target yet — nothing to seed into.
    }
}
